import { Navigate, Route, Routes } from 'react-router-dom';

import { Conversations } from './Conversations';

export const MessagingRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Conversations />} />
      {/* <Route path=":id" element={<Chat />} /> */}
      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
};
